export class TimelineItemEvent {
  constructor(item) {
    this.item = item;
  }
}
export class TimelineItemsEvent {
  constructor(items) {
    this.items = items;
  }
}
export class TimelineItemAdded extends TimelineItemEvent {}
export class TimelineItemUpdated extends TimelineItemEvent {}
export class TimelineItemsUpdated extends TimelineItemsEvent {}
export class TimelineItemRemoved extends TimelineItemEvent {}
export class TimelineViewChanged {
  constructor(pxPerSec, startSec, endSec) {
    this.pxPerSec = pxPerSec;
    this.startSec = startSec;
    this.endSec = endSec;
  }
}